import React from "react";
import Heatmap from "../../../shared/heatmap/Heatmap";
import { actionCreators } from "./redux/heatmapSaga";
import { useSelector } from "react-redux";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";

const HeatmapModule = () => {
  const { fetchHeatmapData } = actionCreators;
  const { short_url, organization_id } = useSelector((state) => state.commonReducer.commonProps);

  return (
    <SectionToggle
      maxHeight="auto"
      autoHeight
      title="Customer Retention Heatmap"
      customClass="class-check-in-heatmap withSticky"
      learnMore={
        <KBLearnMore
          title="Customer Retention Heatmap"
          description="This report shows long-term client engagement through a visual heatmap that highlights when clients are most likely to disengage. These insights help you detect retention risks early and understand patterns across up to 24 months of membership behavior."
          kbUrl={ILEARN_URLS.retention.customerRetentionHeatmap}
        />
      }
      content={
        <>
          <div id="react-heatmap-overlay"></div>
          <Heatmap
            stateName="retentionHeatmap"
            params={{ short_url, organization_id }}
            fetchHeatmapData={fetchHeatmapData}
            includeCrossRegionalVisits={{ value: true }}
          />
        </>
      }
    />
  );
};

export default React.memo(HeatmapModule);
